import { isHTMLContentEmpty } from "helpers/common";
import * as Yup from "yup";

import {
    dateRequiredSchema,
    select2RequiredSchema,
    stringRequiredSchema
} from "utils/validation/validationHelpers";

import { array, object, string } from "yup";

const addTaskPlanTemplateSchema = object().shape({

    task_title: stringRequiredSchema,
    description: stringRequiredSchema,
    strategy: Yup.array().of(
        Yup.object().shape({
            text: Yup.string().required("Strategy text is required"),
            attachments: Yup.array().optional(),
            template_id: Yup.string().nullable(),
            strategyRadio: Yup.string().nullable()
        })
    ),
    date: dateRequiredSchema,
    // startdate: stringRequiredSchema,
    // enddate: stringRequiredSchema, 
    // no_of_sessions: stringRequiredSchema,
    // plan_name: stringRequiredSchema,
    // plan_description: string()
    //     .test(
    //         "plan-description-required",
    //         "Plan Description is required",
    //         (value) => !isHTMLContentEmpty(value)
    //     ),

})

export default addTaskPlanTemplateSchema;
